export default __webpack_public_path__ + "static/media/health.e61c140c.png";